import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import {
  TConfigurationsOverviewCard,
  TContentHubSeriesDetailConfigurationsOverviewFields,
  TContentHubSeriesDetailConfigurationsOverviewParams,
  TContentHubSeriesDetailConfigurationsOverviewProps,
} from '../types/productSeriesDetailConfigurationsOverview.types';

export class ProductSeriesDetailConfigurationsOverviewModel {
  private readonly fields?: TContentHubSeriesDetailConfigurationsOverviewFields;
  private readonly params?: TContentHubSeriesDetailConfigurationsOverviewParams;
  private readonly rendering?: ComponentRendering;

  constructor(props: TContentHubSeriesDetailConfigurationsOverviewProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || undefined;
    this.rendering = props?.rendering;
  }

  get backgroundColor(): string | undefined {
    return BACKGROUND_COLOR_MAP.get(this.params?.backgroundColor || '');
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): string | undefined {
    return this.fields?.apiData?.title;
  }

  get eyebrow(): string | undefined {
    return this.fields?.apiData?.eyebrow;
  }

  get description(): string | undefined {
    return appendRootToRichTextInternalLinks(this.fields?.apiData?.description);
  }

  get configurationsOverviewCard(): TConfigurationsOverviewCard[] {
    return this.fields?.apiData?.innerComponents || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
